import { render, staticRenderFns } from "./CandidateStatus.vue?vue&type=template&id=325128d1"
import script from "./CandidateStatus.vue?vue&type=script&lang=js"
export * from "./CandidateStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports